import React from "react";
import PropTypes from "prop-types";

import Button from "../../shared/button";
import getResumeFilterListingUrl from "../../../utils/helpers/get-resume-filter-listing-url";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import styles from "./styles.css";

const PageNotFoundRevamp = ({
    reloadCarListConnect,
    resetCarListConnect,
    updateSelectedOnScreenFilterConnect,
    clearAllFiltersConnect
}) => {

    const onClickListingPage = () => {
        const absoluteURL = getResumeFilterListingUrl();
        resetCarListConnect();
        reloadCarListConnect(true);
        updateSelectedOnScreenFilterConnect("");
        clearAllFiltersConnect();
        // trackEvent("find_car");
        window.location.href = absoluteURL;
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.THREE_HUNDRED_CTA);
        window.setTimeout(() => window.scrollTo(0, 0));
    };

    return (
        <div styleName={"styles.outer"}>
            <div className={"container"}>
                <div styleName={"styles.contentWrapper"}>
                    <p styleName={"styles.notFoundHeading"}>Page not found!</p>
                    <p styleName={"styles.notFoundText"}>Uh no, we can’t seem to find the page you’re looking for. It’s never too late. Begin exploring and find your dream car now </p>
                    <Button text="SEARCH NOW" onClick={onClickListingPage}/>
                </div>
            </div>
        </div>
    );
};

PageNotFoundRevamp.propTypes = {
    reloadCarListConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func
};
export default PageNotFoundRevamp;
